module.exports = __webpack_public_path__ + "img/select.4cfa9fa8.svg";